const topbar = {
    docs: '文件',
    help: '幫助',
};
export default Object.freeze(topbar);
